import './style.scss';

export const View = () => {
    return <div>Сash income</div>;
};
